var PlayVideo = function(){
        this.init();
};

PlayVideo.prototype = {
    init: function() {
        $('.js-video-thumb').find('a').on('click', function(e){
            e.preventDefault();
            var $this = $(this);
            var $target = $($this.attr('href'));
            var $video = document.getElementById($($this.attr('href')+'-src').attr('id'));

            $target.addClass('is-open');
            setTimeout(function(){
                $video.play();
            }, 1000);
        });

        $('.js-video-modal').on('click', function(e){
            e.preventDefault();
            var $this = $(this);
            var $video = document.getElementById($this.find('video').attr('id'));
            setTimeout(function(){
                $video.pause();
            }, 1000);
            $this.removeClass('is-open');
        });
    }
};

module.exports = PlayVideo;


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/module/play_video.js
 ** module id = 7
 ** module chunks = 5
 **/